var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF0900",
    points: "17.1981431 18.8461538 14.6307584 18.8461538 13.8270661 9 17.9993738 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.88922,20.8998154 C17.20122,20.8998154 18.2670661,21.9656615 18.2670661,23.2776615 C18.2670661,24.5625846 17.20122,25.6284308 15.88922,25.6284308 C14.57722,25.6284308 13.5384507,24.5625846 13.5384507,23.2776615 C13.5384507,21.9656615 14.57722,20.8998154 15.88922,20.8998154",
    id: "Fill-6",
    fill: "#FF0900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54477443,23.6263259 C-0.00272991117,26.3194518 1.93110638,29.6875 5.02611505,29.6875 L16.0001191,29.6875 L26.9741231,29.6875 C30.0680435,29.6875 32.0029681,26.3194518 30.4554637,23.6263259 L19.4814597,4.52066485 C17.9339554,1.82644505 14.0662828,1.82644505 12.5187785,4.52066485 L1.54477443,23.6263259 Z",
    id: "Fill-1",
    stroke: "#FF0900",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a8ff6b714975e0245fec65c1053dbe75.svg";
export { ForwardRef as ReactComponent };